<template>
  <TableGradient
      icon-name="cubes"
      :title="$t('result_range.index.listagem_faixa_resultado')"
      :text-empty="$t('result_range.index.faixa_resultado_nao_encontrada')"
      table-data
      route-new="resultrange.create"
      :text-new="$t('result_range.index.criar_faixa_resultado')"
      :fields="fields"
      :fields-filter="filter"
      :items="resultranges"
      :loading="isLoading"
      :paginator="paginator"
      @list="evt => $store.dispatch('dexpara/resultrange/listAllPaginated', evt)">
    <template v-slot:cell(mapping_result_range_status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.mapping_result_range_status, 'badge badge-danger': !linha.item.mapping_result_range_status}">
          <i :class="linha.item.mapping_result_range_status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
    <template v-slot:cell(id)="{index, item}">
      <router-link
        :id="`link-edit-${index}`"
        :to="{ name: 'resultrange.edit', params: { id: item.mapping_result_range_id }}"
        class="font-weight-bold"
      >
      {{ $t('result_range.index.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableSimple from "@/components/TableSimple";
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  name: "Index",
  components: {TableGradient, TableSimple},
  computed: {
    ...mapGetters({
      resultranges: 'dexpara/resultrange/all',
      store_isLoading: 'dexpara/resultrange/isLoading',
      paginator: 'dexpara/resultrange/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [        
        {key: 'vns_integration_origin_name', label: this.$t('result_range.index.origem'), sortable: true},
        {key: 'vns_integration_destination_name', label: this.$t('result_range.index.destino'), sortable: true},
        {key: 'tuevs_exam_name', label: this.$t('result_range.index.exame'), sortable: true},
        {key: 'mapping_result_range_status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('result_range.index.editar')},
      ],
      filter: [
        {key: 'origin.name', label: this.$t('result_range.index.origem')},
        {key: 'destination.name', label: this.$t('result_range.index.destino')},
        {key: 'tuevs_exams.name', label: this.$t('result_range.index.exame')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'dexpara/resultrange/listAllPaginated'
    ]),
    ...mapMutations([
      'resultrange/setAll'
    ])    
  },
  async mounted() {
    await this['dexpara/resultrange/listAllPaginated'](this.paginator)
    this.mounted = true
  }
}
</script>
